import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import { loginSuccess as loginSuccessReducer, loginFail as loginFailReducer, logout as logoutReducer } from './reducer';

export const loginSlice = createSlice({
  name: 'login',
  initialState: initialState,
  reducers: {
    loginSuccess: loginSuccessReducer,
    loginFail: loginFailReducer,
    logout: logoutReducer,
  },
});

export const { loginSuccess, loginFail, logout } = loginSlice.actions;

/*
async example
export const incrementAsync = (amount) => (dispatch) => {
  setTimeout(() => {
    dispatch(incrementByAmount(amount))
  }, 1000)
}
*/
export const isLogged = (state) => state.login.isLogged;

export default loginSlice.reducer;
